__turbopack_context__.v({
  "description": "index-module__lkXZKW__description",
  "downloadButton": "index-module__lkXZKW__downloadButton",
  "skeleton-wave": "index-module__lkXZKW__skeleton-wave",
  "skeletonWave": "index-module__lkXZKW__skeletonWave",
  "wrapper": "index-module__lkXZKW__wrapper",
  "zoomSlider": "index-module__lkXZKW__zoomSlider",
});
